import { render } from "./AvioOprema.vue?vue&type=template&id=6f5b0641&scoped=true"
import script from "./AvioOprema.vue?vue&type=script&lang=js"
export * from "./AvioOprema.vue?vue&type=script&lang=js"

import "./AvioOprema.vue?vue&type=style&index=0&id=6f5b0641&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f5b0641"]])

export default __exports__